import DapDSFileInputList from './file-input-list.component'

export * from './file-input-list.component'
export default DapDSFileInputList

DapDSFileInputList.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-file-input-list': DapDSFileInputList
  }
}
